import React from "react";
import { Stack, Typography } from "@mui/material";

const CustomSection = ({ title, children, sx }) => {
  return (
    <Stack
      display="flex"
      alignItems="center"
      direction="row"
      spacing={3}
      padding={3}
      sx={{ borderBottom: "1px solid #d3d3d3", ...sx }}
    >
      <Typography sx={{ textAlign: "left", width: 200 }} fontSize={20}>
        {title}
      </Typography>
      {children}
    </Stack>
  );
};

export default CustomSection;
